<template>
  <div>
    <async-load-comp
    ></async-load-comp>
  </div>
</template>
<script>
import Vue from "vue";
import asyncLoadComp from "../custom/asyncLoadComp";
import Wp_page_test from "../pages/Wp_page_test";

export default {
  name: "x",
  components: {
    asyncLoadComp,
    Wp_page_test
  },
  data() {
    return {
      comps: ["Wp_page_test", "Wp_page_test"],
      prop: { test_name: "张三" }
    };
  },
  created() {
    this.initUI();
  },
  methods: {
    initUI2() {
      Vue.component(Wp_page_test, {
        template: "#anchored-heading-template",
        props: {
          level: {
            type: Number,
            required: true
          }
        }
      });
    },
    initUI() {
      new Vue({
        el: "#app",
        data: {
          message: "hello world"
        },
        render: function(createElement) {
          return createElement(
            Wp_page_test,
            {
              props: {
                test_name: "UI测试"
              },
              on: {
                clock: () => {}
              }
            },
            "Delete"
          );
        }
      });
    }
  },
};
</script>